import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
    refresh() {
        this.element.src = location.href;
        this.element.src = '';
    }
}
